import { CardItem } from '../components/CardItem';

export const rainLocator: CardItem[] = [
  {
    title: 'Localização das chuvas em tempo real',
    description:
      'Localização das chuvas em tempo real e para as próximas horas no Rio Grande do Sul.',
    image: ['/images/mapa/chuvas-em-tempo-real.jpg'],
    alt: 'Imagem de mapa',
    link: 'https://www.windy.com/pt/-Radar-meteorol%C3%B3gico-radar?radar,-30.401,-51.985,7',
    source: null,
  },
  {
    title: 'Localização das chuvas para os próximos 5 dias',
    description:
      'Localização das chuvas para os próximos 5 dias no Rio Grande do Sul.',

    image: ['/images/mapa/chuvas-proximos-5-dias.jpg'],
    alt: 'Imagem de mapa',
    link: 'https://www.windy.com/pt/-Chuva-trov%C3%A3o-rain?rain,-30.401,-51.985,7',
    source: null,
  },
  {
    title: 'Acumulado de chuvas para os próximos 5 dias',
    description:
      'Acumulado de chuvas para os próximos 5 dias no Rio Grande do Sul.',

    image: ['/images/mapa/acumulado-de-chuvas.jpg'],
    alt: 'Imagem de mapa',
    link: 'https://www.windy.com/pt/-Acumula%C3%A7%C3%A3o-de-chuva-rainAccu?rainAccu,-30.401,-51.985,7',
    source: null,
  },
];
